import { getCsrfValue } from "~/common/utils/ApiHelper";

import instance from "~/utils/i18n";
import { DateFormatType, getPattern } from "~/common/utils/DateFormatter";
import { resolveApiUrl } from "~/utils/url/urlResolver";
import { type OrderLineItemData } from "~/domains/orders/types/modelsV2";

interface Props {
  comment: string;
  subjectOfRequest: string;
  subjectCode: string;
  soNumber: string;
  poNumber: string;
  orderDetailsEntryData: OrderLineItemData;
  packagingLabel: string;
  salesOrg?: string;
  accountNumber?: string;
  subLineNo?: string;
}

const apiUrl = resolveApiUrl("/feedback/send");

export function apiSendRequest({
  comment,
  subjectOfRequest,
  soNumber,
  poNumber,
  orderDetailsEntryData,
  packagingLabel,
  subjectCode,
  salesOrg,
  accountNumber,
  subLineNo,
}: Props): Promise<unknown> {
  const data = {
    salesOrderNumber: soNumber,
    purchaseOrderNumber: poNumber,
    reasonOfRequest: subjectOfRequest,
    reasonCode: subjectCode,
    feedbackMessage: comment,
    priceUnit: instance.t("common.product.perPiece", { count: orderDetailsEntryData.netPrice.unit }),
    weightUnit: instance.t("common.product.perPiece", { count: 1 }),
    packaging: packagingLabel,
    dateFormat: getPattern(DateFormatType.DATE).replace("DD", "dd").replace("YYYY", "yyyy"),
    lineNumber: subLineNo ?? orderDetailsEntryData.lineNo,
    salesOrg,
    account: accountNumber,
  };
  return fetch(apiUrl, {
    body: JSON.stringify(data),
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    mode: "cors",
    headers: {
      dataType: "json",
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
    redirect: "follow",
  }).then((result) => {
    if (result.ok) {
      return true;
    } else {
      throw new Error(result.status + "");
    }
  });
}
